<template>
  <div class="nx-site-selector-wrapper">
    <v-select
      class="nx-site-selector"
      chips
      :multiple="multiple"
      :items="items"
      :value="internalValue"
      item-text="name"
      item-value="id"
      v-bind="$attrs"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      @input="onInput"
    ></v-select>
  </div>
</template>

<script>
import { toArray } from '@/utils';
import isObject from 'lodash/isObject';

export default {
  name: 'nx-site-selector',
  props: {
    value: {
      type: [Array, Number, String, Object],
    },
    emitObject: {
      type: Boolean,
      default: () => false,
    },
    multiple: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    items() {
      return this.$store.getters.availableSites;
    },
    internalValue() {
      if (this.multiple) {
        return toArray(this.value).map(val => Number.parseInt(val, 10));
      }
      if (isObject(this.value) && this.value.id) {
        return this.value.id;
      }
      return this.value ? Number.parseInt(this.value, 10) : this.value;
    },
  },
  methods: {
    onInput(input) {
      if (this.multiple) {
        this.$emit('input', this.emitObject ? this.items.filter(site => input.includes(site.id)) : input);
      } else {
        this.$emit('input', this.emitObject ? this.items.find(site => site.id === input) : input);
      }
    },
  },
};
</script>
